export default function GameOverUI(score) {
  const gameOverUI = document.getElementById("gameOver");
  gameOverUI.hidden = false;

  const restartBtn = document.getElementById("restart");
  restartBtn.hidden = false;

  gameOverUI.innerHTML = `Game Over! <br> Score: ${score}`;
}
